// components

// react
import { useEffect, useState } from 'react';
import { useLocation } from "react-router";
import { useHistory } from "react-router-dom";
import { Route, Switch } from "react-router-dom";
import { BeatLoader } from 'react-spinners';
import FilePreview from "react-preview-file";

// kendo
import kendo from "@progress/kendo-ui";
import { Checkbox } from '@progress/kendo-react-inputs';
import { Dialog } from '@progress/kendo-react-dialogs';
import { Window } from '@progress/kendo-react-dialogs';

// css
import styles from './userDetail_mobile.module.css';
import "./userDetail_mobile.css";

// services
import { authGuest, setDelToken, setToken, getUser, isUser } from "../../../service/authService";
import { getUserStatPage } from '../../../service/monitor/allStatusService';
import { setAbsenceYn, setDangerYn, setInstallPlan } from '../../../service/mobile/userInfoService';
import { getFile } from '../../../service/mngt/elderService';

function UserDetailMobile({conn, setUpdateLoginStatus, loginStatus}) {

  const userInfo = getUser();
  const history = useHistory();
  const locationState = useLocation().state;
  const [loading, setLoading] = useState(false);
  const [completeDialogVisible, setCompleteDialogVisible] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("변경되었습니다.");

  const [dataState, setDataState] = useState({
    userId: locationState.userId,
    absenceYn: locationState.absenceYn,
    dangerYn: locationState.dangerYn,
    meainStatCode: locationState.meainStatCode,
    fileIdUserPhoto: locationState.fileIdUserPhoto,
    fileIdPlacePhoto1: locationState.fileIdPlacePhoto1,
    fileIdPlacePhoto2: locationState.fileIdPlacePhoto2,
  })

  const [imgFile, setImgFile] = useState({
    imgFileUserPhoto: "",
  });
  
  //사진 등록 시 미리보기
  const [previewFile, setPreviewFile] = useState({
    previewFileUserPhoto: "",
  });

  const closeCompleteDialog = () => {
    setCompleteDialogVisible(false);
  }

  const viewPlacePhoto = () => {
    // setPlacePhotoVisible(true);
    history.push({
      pathname: "/user/info/placePhoto",
      state: { dataState },
    });
  }

  const updatePhoto = () => {
    history.push({
      pathname: "/user/info/changePhoto",
      state: { dataState },
    });
  }

  const genderIcon = () => {
    if(locationState.userGender === "M") {
      return <img className="genderIcon" src="/images/mobile/icon_man.png"></img>
    } else {
      return <img className="genderIcon" src="/images/mobile/icon_woman2.png"></img>
    }
  }

  const checkboxEvent = (e) => {
    if(e.value) {
      if(e.target.element.id === "longAbsence") {
        setDialogMessage("장기부재 상태로 변경되었습니다.");
        setDataState((dataState) => {
          const item = { ...dataState };
          item.absenceYn = "Y"
          setAbsenceYn(conn, item)
          .then((response) => {
            setCompleteDialogVisible(true);
          })
          .catch((err) => {
            console.log("setAbsenceYn err = ", err);
          });
          return item;
        })
      } else if(e.target.element.id === "dangerUser"){
        setDialogMessage("위험대상자로 변경되었습니다.");
        setDataState((dataState) => {
          const item = { ...dataState };
          item.dangerYn = "Y"
          setDangerYn(conn, item)
          .then((response) => {
            setCompleteDialogVisible(true);
          })
          .catch((err) => {
            console.log("setDangerYn err = ", err);
          });
          return item;
        })
      } else if(e.target.element.id === "installPlan"){
        setDialogMessage("설치예정 대상자로 전환되었습니다.");
        setDataState((dataState) => {
          const item = { ...dataState };
          item.meainStatCode = "20005"
          setInstallPlan(conn, item)
          .then((response) => {
            setCompleteDialogVisible(true);
          })
          .catch((err) => {
            console.log("setDangerYn err = ", err);
          });
          return item;
        })
      }
    } else {
      if(e.target.element.id === "longAbsence") {
        setDialogMessage("장기부재 상태가 해제되었습니다.");
        setDataState((dataState) => {
          const item = { ...dataState };
          item.absenceYn = "N"
          setAbsenceYn(conn, item)
          .then((response) => {
            setCompleteDialogVisible(true);
          })
          .catch((err) => {
            console.log("setAbsenceYn err = ", err);
          });
          return item;
        })
      } else if(e.target.element.id === "dangerUser"){
        setDialogMessage("위험대상자가 해제되었습니다.");
        setDataState((dataState) => {
          const item = { ...dataState };
          item.dangerYn = "N"
          setDangerYn(conn, item)
          .then((response) => {
            setCompleteDialogVisible(true);
          })
          .catch((err) => {
            console.log("setDangerYn err = ", err);
          });
          return item;
        })
      } else if(e.target.element.id === "installPlan"){
        setDialogMessage("설치예정 대상자가 해제되었습니다.");
        setDataState((dataState) => {
          const item = { ...dataState };
          item.meainStatCode = "20003"
          setInstallPlan(conn, item)
          .then((response) => {
            setCompleteDialogVisible(true);
          })
          .catch((err) => {
            console.log("setDangerYn err = ", err);
          });
          return item;
        })
      }
    }
  }

  const userPhoto = () => {
    getFile(conn, dataState.fileIdUserPhoto)
    .then(fileResponse => {
      const dataUri = 'data:image/png;base64,' + fileResponse;
      setImgFile((imgFile) => {
        const item = { ...imgFile};
        item.imgFileUserPhoto = dataUri;
        return item;
      });
    })
    .catch(err => {
      console.log("getFile err = ", err);
    })
  }

  useEffect(() => {
    userPhoto();
  },[])

  return (
    <>
      <div className="pageContent_m">
        <div className="userInfoDetail">
          <div className={styles.firstBox}>
            <div className={styles.left}>
              {
                locationState.fileIdUserPhoto ? (
                  <img className={styles.userPhoto} src={imgFile.imgFileUserPhoto} />
                ) : (
                <img className={styles.userPhoto} src="/images/mobile/photo.png" />
                )
              }
            </div>
            <div className={styles.right}>
              <div className={styles.rightTop}>
                <div className="infoTitle">성함</div>
                <div className="infoContent">
                  <p className="content_01">{locationState.userTerm}</p>
                </div>
              </div>
              <div className={styles.rightBottom}>
                <button className={styles.photoButton} style={{marginBottom: "1vh"}} onClick={viewPlacePhoto}>현장 사진 보기</button>
                <button className={styles.photoButton} onClick={updatePhoto}>사진 추가 / 수정</button>
              </div>
            </div>
          </div>
          <div className="infoTitle">생년월일</div>
          <div className="infoContent" style={{display: "flex", justifyContent: "space-between"}}>
            <p className="content_01">{locationState.birthday}</p>
            <p className="content_02" style={{float: "right", paddingLeft: "3vw", borderLeft: "1px solid #c4c4c4"}}>{genderIcon()}</p>
          </div>
          <div className="infoTitle">상세주소</div>
          <div className="infoContent">
            <p className="content_01">{locationState.dongTerm}</p>
            <p className="content_02">{locationState.address}</p>
          </div>
          <div className="infoTitle">연락처</div>
          <div className="infoContent">
            <p className="content_01">{locationState.userPhone}</p>
          </div>
          <div className="infoTitle">보호자 연락처</div>
          <div className="infoContent">
            <p className="content_01">{locationState.protectorPhone}</p>
          </div>
          <div className="infoTitle">보유질환</div>
          <div className="infoContent" style={{minHeight: "20vw"}}>
            <p className="content_01">{locationState.sickType}</p>
          </div>
          <div className="infoTitle">특이사항</div>
          <div className="infoContent" style={{minHeight: "16vw"}}>
            <p className="content_01">{locationState.note}</p>
          </div>
          {userInfo.userTypeCode !== 2001 && userInfo.userTypeCode !== 2006 ?
            <div className="checkboxDiv">
              <div className="checkbox">관리대상자<Checkbox id="dangerUser" defaultChecked={dataState.dangerYn === "Y"} label={false} onChange={checkboxEvent}/></div>
              <div className="checkboxText">- 체크 시 관리 대상자로 전환</div>
              <div className="checkbox">장기부재<Checkbox id="longAbsence" defaultChecked={dataState.absenceYn === "Y"} label={false} onChange={checkboxEvent}/></div>
              <div className="checkboxText">- 체크 시 위험 상태로 전환되지 않음</div>
              <div className="checkbox">설치예정<Checkbox id="installPlan" defaultChecked={dataState.meainStatCode === "20005"} label={false} onChange={checkboxEvent}/></div>
              <div className="checkboxText">- 체크 시 설치예정 대상자로 전환</div>
            </div>
            : null
          }
        </div>
      </div>
      {loading && (
        <p
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50%)',
          }}>
          <BeatLoader loading={true} size={18} color="#5e9dd4" />
        </p>
      )}
      {completeDialogVisible && (
        <Dialog
          className="completeDialog"
          width={"90vw"}
          height={"40vw"}
          closeIcon={false}
        >
          <p>
            {dialogMessage}
            <br></br>
            <button onClick={closeCompleteDialog}>확인</button>
          </p>
        </Dialog>
      )}
    </>
  );
}

export default UserDetailMobile;
